<template>
  <div class="overflow-auto">
    <modal @close="close">
      <div slot="modal-header">
        {{ $t('general.request') }}
      </div>
      <div class="divTable blueTable border-bottom">
        <div class="divTableHeading ">
          <div class="divTableRow">
            <div class="divTableHead text-center">
              {{ $t('general.selection') }}
            </div>
            <div class="divTableHead text-center">
              {{ $t('general.preview') }}
            </div>
            <div class="divTableHead text-center">
              {{ $t('general.mixing_ratio') }}
            </div>
          </div>
        </div>
        <div class="divTableBody">
          <div v-for="data in mixerData" :key="data.id" class="divTableRow">
            <div class="divTableCell text-center">
              <el-switch v-model="data.checked" />
            </div>
            <div class="divTableCell text-center">
              <img :alt="data.id" class="img rounded border" :src="data.image" />
            </div>
            <div class="divTableCell text-center">
              <div class="d-flex align-content-between justify-content-center">
                <span
                  v-for="color in data.colors"
                  :key="color.id"
                  class="preview-color-square rounded mr-2 font-weight-bold"
                  :style="{ background: color.color.hex }"
                >
                  <span v-if="color.amount > 0">{{ color.amount }}%</span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mt-2">
        <span class="font-weight-light">{{ $t('general.remarks') }}</span>
        <el-input v-model="remarks" type="textarea" :rows="2"> </el-input>
      </div>
      <div slot="modal-footer">
        <el-button @click="close">
          {{ $t('general.close') }}
        </el-button>
        <el-button :disabled="nothingSelected" @click="submit">
          {{ $t('general.submit') }}
        </el-button>
      </div>
    </modal>
  </div>
</template>

<script>
import Modal from '../atoms/Modal';
export default {
  name: 'RequestMixerModal',
  components: { Modal },
  props: {
    mixerData: Array,
    type: String,
  },
  mounted() {},
  destroyed() {},
  data() {
    return {
      remarks: '',
    };
  },
  computed: {
    nothingSelected() {
      return this.mixerData.filter((el) => el.checked).length === 0;
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
    async submit() {
      let submitItems = this.mixerData.filter((el) => el.checked);

      let data = {
        remarks: this.remarks,
        data: submitItems,
      };

      let object = new this.$parse.Object('MixerRequest');
      object.set('notes', this.remarks);
      object.set('type', this.type);
      object.set('content', data);
      object.set('user', this.$parse.User.current());

      await object.save();
      this.$message.info(this.$t('messages.mixer_request_success'));
      this.close();
    },
  },
};
</script>

<style scoped>
.preview-color-square {
  width: 30px;
  height: 30px;
  margin-right: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.preview-color-square span {
  padding: 2px;
  font-size: 10px;
  border-radius: 5px;
  text-align: center;
  color: white;
  text-shadow: 1px 1px 1px black, 1px -1px 1px black, -1px 1px 1px black, -1px -1px 1px black;
}
div.blueTable {
  width: 100%;
  text-align: left;
  border-collapse: collapse;
}
.divTable.blueTable .divTableCell,
.divTable.blueTable .divTableHead {
  padding: 10px 15px;
}
.divTable.blueTable .divTableBody .divTableCell {
  font-size: 13px;
}
.divTable.blueTable .divTableRow:nth-child(even) {
}
.divTable.blueTable .divTableHeading {
}
.divTable.blueTable .divTableHeading .divTableHead {
  font-size: 15px;
  font-weight: bold;
}
.divTable.blueTable .divTableHeading .divTableHead:first-child {
  border-left: none;
}

.blueTable .tableFootStyle {
  font-size: 14px;
}
.blueTable .tableFootStyle .links {
  text-align: right;
}
.blueTable .tableFootStyle .links a {
  display: inline-block;

  padding: 2px 8px;
  border-radius: 5px;
}
.blueTable.outerTableFooter {
  border-top: none;
}
.blueTable.outerTableFooter .tableFootStyle {
  padding: 3px 5px;
}
/* DivTable.com */
.divTable {
  display: table;
}
.divTableRow {
  display: table-row;
}
.divTableHeading {
  display: table-header-group;
}
.divTableCell,
.divTableHead {
  display: table-cell;
}
.divTableHeading {
  display: table-header-group;
}

.divTableBody {
  display: table-row-group;
}
img {
  max-width: 100%;
  height: auto;
}
</style>
